<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>

export default {
    name: 'App',
    watch: {
        '$i18n.locale': {
            immediate: true,
            handler(locale) {
                this.applyLocaleFont(locale);
            }
        }
    },
    methods: {
        applyLocaleFont(locale) {
            document.documentElement.setAttribute('data-locale', locale);
            document.body.setAttribute('data-locale', locale);
        }
    },
    mounted() {
        this.applyLocaleFont(this.$i18n.locale);
    }
}
</script>

<style lang="less">
//全局自定义样式
@import './common/css/global.less';

@basicFontColor: #3d4d65;

* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

html, body {
    width: 100%;
    height: 100%;
    margin: 0;
    font-family: "Open Sans", "Aptos", Helvetica, sans-serif;
}

/* Login pages: prevent white overscroll/gap on mobile */
html.is-login-page,
html.is-login-page body,
html.is-login-page #app {
    background-color: #000 !important;
    height: 100%;
    min-height: 100%;
    overscroll-behavior: none;
}

/* Client mobile pages: black under footer / overscroll */
html.is-client-mobile,
html.is-client-mobile body,
html.is-client-mobile #app {
    background-color: #000 !important;
    overscroll-behavior-y: none;
}

html[data-locale="zh-CN"],
html[data-locale="zh-CN"] body,
html[data-locale="zh-CN"] #app,
html[data-locale="zh-CN"] * ,
html[data-locale="zh-TW"],
html[data-locale="zh-TW"] body,
html[data-locale="zh-TW"] #app,
html[data-locale="zh-TW"] * {
    font-family: "Noto Sans SC", "Microsoft YaHei", sans-serif !important;
}

html[data-locale="zh-CN"] [class^="el-icon-"],
html[data-locale="zh-CN"] [class*=" el-icon-"],
html[data-locale="zh-CN"] [class^="el-icon-"]::before,
html[data-locale="zh-CN"] [class*=" el-icon-"]::before,
html[data-locale="zh-TW"] [class^="el-icon-"],
html[data-locale="zh-TW"] [class*=" el-icon-"],
html[data-locale="zh-TW"] [class^="el-icon-"]::before,
html[data-locale="zh-TW"] [class*=" el-icon-"]::before {
    font-family: "element-icons" !important;
}

#app {
    height: 100%;
    width: 100%;
}

.green {
    color: #007CB0;
}

.ant-select-dropdown-menu-item-selected {
    min-height: 32px;
}

.ant-select-dropdown-menu-item {
    min-height: 32px;
}
</style>
